'use client';

import { useLocale } from 'next-intl';
import { ReCaptchaProvider } from 'next-recaptcha-v3';
import { type PropsWithChildren } from 'react';

import { RECAPTCHA_KEY } from '@commons/utils/constants';

/**
 * Google ReCaptcha provider.
 *
 * Loads the Google ReCaptcha script and provides a context to generate tokens.
 *
 * @see https://github.com/snelsi/next-recaptcha-v3
 */

const GoogleReCaptchaProvider = ({ children }: PropsWithChildren) => {
  const locale = useLocale();

  return (
    <ReCaptchaProvider reCaptchaKey={RECAPTCHA_KEY} language={locale} strategy="lazyOnload">
      {children}
    </ReCaptchaProvider>
  );
};

export default GoogleReCaptchaProvider;
